import * as types from './mutation-type'

const mutations = {
  // 添加元素
  [types.ADD_ELEMENT](state, element) {
    // 添加新元素之前，将之前的元素selected变为false
    state.elements.forEach(function(item) {
      item.selected = false
    })
    state.elements.push(element)
  },
  // 删除所有元素
  [types.DELETE_ALL_ELEMENT](state) {
    state.elements = []
  },
  // 选中某一个元素
  [types.SELECTED_ONE_ELEMENT](state, index) {
    state.elements.forEach(function(item) {
      item.selected = false
    })
    state.elements[index].selected = true
  }
}

export default mutations
